import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { ClassificationsApi, type ClassificationsParams } from '@/api/domains/classifications.api';
import { ClassificationsQueryKeys } from '@/api/domains/classifications.query-keys';

// ----------------------------------------------------------------------

export const useClassifications = (config: ClassificationsParams & Pick<UseQueryOptions, 'enabled'>) => {
  const { enabled, ...params } = config;

  const { isLoading, isFetching, data } = useQuery({
    queryKey: ClassificationsQueryKeys.classifications(params),
    queryFn: () => ClassificationsApi.fetchClassifications(params),
    enabled,
    staleTime: Infinity,
  });

  const classifications = data?.items || [];

  return { isLoading, isFetching, classifications };
};
